import { customerSchema } from './../traders/getCustomers';
import { z } from 'zod';

const groupItemCustomer = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean().optional(),
  groupItemId: z.string(),
  mwAccountGroupId: z.string(),
  deleted: z.boolean().optional(),
  customer: customerSchema,
});

export const getGroupItemsCustomerForGroupItemIdSchema = z.array(groupItemCustomer);

export type GetGroupItemsCustomerForGroupItemIdResponse = z.infer<
  typeof getGroupItemsCustomerForGroupItemIdSchema
>;
